<template>
  <ion-page>
    <ion-content class="main-background" :fullscreen="true" slot="fixed" :scroll-y="false">
      <div class="offline-backdrop" v-show="showOfflineSelector"></div>

      <div class="top-safe-area"></div>
        <ion-button v-on:click="returnBack(prevRouteName)" class="header-sm-button bg-transparent top-level white-regular">
        <ion-icon slot="start" :icon="arrowBackOutline"></ion-icon>
      </ion-button>

      <ion-button v-on:click="returnBack('Today')"
        class="header-sm-button header-sm-button-right bg-transparent top-level white-regular">
        <ion-icon slot="end" :icon="homeOutline"></ion-icon>
      </ion-button>

      <div class="offline-select-container" v-show="showOfflineSelector">
        <ion-list lines="none">
          <div class="offline-select-header">
            <ion-icon :icon="close" v-show="!isDownloading" class="close-icon" @click="hideOfflineSelector()"></ion-icon>
          </div>
          <ion-list-header>
            <ion-label>Оффлайн доступ</ion-label>
          </ion-list-header>
          <ion-item :class="[
            'online-item',
            releaseEntity.musicOffline &&
              !downloadProgress.get('music')?.downloading
              ? 'offline-item'
              : '',
          ]">
            <ion-label>Музыка</ion-label>
            <ion-text slot="end" v-show="downloadProgress.get('music')?.downloading">
              {{ downloadProgress.get("music")?.percentage }}%
            </ion-text>
            <ion-icon :icon="cloudDownloadOutline" slot="end" v-show="!releaseEntity.musicOffline &&
              !downloadProgress.get('music')?.downloading
              " @click="downloadRelease('music')"></ion-icon>
            <ion-icon :icon="stopCircle" slot="end" v-show="downloadProgress.get('music')?.downloading"
              @click="stopDownload('music')"></ion-icon>
            <ion-icon :icon="trash" slot="end" v-show="!downloadProgress.get('music')?.downloading &&
              releaseEntity.musicOffline
              " @click="removeReleaseEntityDirectory('music')"></ion-icon>
            <div class="offline-progress-bottom" v-show="downloadProgress.get('music')?.downloading" :style="{
              width: `${downloadProgress.get('music')?.percentage || 0}%`,
            }"></div>
          </ion-item>
          <ion-item :class="[
            'online-item',
            releaseEntity.videoOffline &&
              !downloadProgress.get('video')?.downloading
              ? 'offline-item'
              : '',
          ]">
            <ion-label >Видео</ion-label>
            <ion-text slot="end" v-show="downloadProgress.get('video')?.downloading">
              {{ downloadProgress.get("video")?.percentage }}%
            </ion-text>
            <ion-icon :icon="cloudDownloadOutline" slot="end" v-show="!releaseEntity.videoOffline &&
              !downloadProgress.get('video')?.downloading
              " @click="downloadRelease('video')"></ion-icon>
            <ion-icon :icon="stopCircle" slot="end" v-show="downloadProgress.get('video')?.downloading"
              @click="stopDownload('video')"></ion-icon>
            <ion-icon :icon="trash" slot="end" v-show="!downloadProgress.get('video')?.downloading &&
              releaseEntity.videoOffline
              " @click="removeReleaseEntityDirectory('video')"></ion-icon>
            <div class="offline-progress-bottom" v-show="downloadProgress.get('video')?.downloading" :style="{
              width: `${downloadProgress.get('video')?.percentage || 0}%`,
            }"></div>
          </ion-item>
          <ion-item :class="[
            'online-item',
            releaseEntity.guideOffline &&
              !downloadProgress.get('guide')?.downloading
              ? 'offline-item'
              : '',
          ]">
            <ion-label >Гайд</ion-label>
            <ion-text slot="end" v-show="downloadProgress.get('guide')?.downloading">
              {{ downloadProgress.get("guide")?.percentage }}%
            </ion-text>
            <ion-icon :icon="cloudDownloadOutline" slot="end" v-show="!releaseEntity.guideOffline &&
              !downloadProgress.get('guide')?.downloading
              " @click="downloadRelease('guide')"></ion-icon>
            <ion-icon :icon="stopCircle" slot="end" v-show="downloadProgress.get('guide')?.downloading"
              @click="stopDownload('guide')"></ion-icon>
            <ion-icon :icon="trash" slot="end" v-show="!downloadProgress.get('guide')?.downloading &&
              releaseEntity.guideOffline
              " @click="removeReleaseEntityDirectory('guide')"></ion-icon>
            <div class="offline-progress-bottom" v-show="downloadProgress.get('guide')?.downloading" :style="{
              width: `${downloadProgress.get('guide')?.percentage || 0}%`,
            }"></div>
          </ion-item>
        </ion-list>
      </div>

      <div class="release-page-background" style="margin-top: 5em;" v-show="storedReleaseImagePath.length > 0">
        <img :src="storedReleaseImagePath" alt="program page" ref="programImageRef" />

        <div class="media-buttons">
          <ion-button v-on:click="openReleaseDetail('ReleaseMusic')" class="media-button" :disabled="isDownloading ||
            (!releaseEntity.musicOffline && globalContext.offlineMode)
            ">
            <ion-icon :icon="musicalNotesOutline"></ion-icon>
          </ion-button>
          <ion-button v-on:click="openReleaseDetail('ReleaseVideo')" class="media-button media-button-middle" :disabled="isDownloading ||
            (!releaseEntity.videoOffline && globalContext.offlineMode)
            ">
            <ion-icon :icon="filmOutline"></ion-icon>
          </ion-button>
          <ion-button v-on:click="openReleaseDetail('ReleaseGuide')" class="media-button" :disabled="isDownloading ||
            (!releaseEntity.guideOffline && globalContext.offlineMode)
            ">
            <ion-icon :icon="documentOutline"></ion-icon>
          </ion-button>
        </div>
      </div>

      <div :class="['bottom-buttons-container', isLandscapeMode ? 'bottom-buttons-container-landscape' : '']">
        <ion-button @click="showOfflineSelector = true" class="download-button"
          v-show="!isDownloading && !globalContext.offlineMode && isMobile">
          <ion-icon :icon="cloudDownload" v-show="!releaseEntity.musicOffline || !releaseEntity.videoOffline
            "></ion-icon>
          <ion-label v-show="!releaseEntity.musicOffline || !releaseEntity.videoOffline
            " class="ion-margin-start">Загрузить оффлайн</ion-label>

          <ion-icon :icon="cloudDone" v-show="releaseEntity.musicOffline &&
            releaseEntity.videoOffline &&
            releaseEntity.guideOffline
            "></ion-icon>
          <ion-label v-show="releaseEntity.musicOffline && releaseEntity.videoOffline" class="ion-margin-start">Доступно
            оффлайн</ion-label>
        </ion-button>

        <div :class="['admin-buttons', isLandscapeMode ? 'admin-buttons-landscape' : '']">
          <ion-button class="download-button" @click="changeReleaseVisibility(!releaseVisible)"
            v-show="globalContext.isManager && !globalContext.offlineMode">
            <ion-icon :icon="eye" v-show="!releaseVisible"></ion-icon>
            <ion-label v-show="!releaseVisible" class="ion-margin-start">Опубликовать</ion-label>

            <ion-icon :icon="eyeOff" v-show="releaseVisible"></ion-icon>
            <ion-label v-show="releaseVisible" class="ion-margin-start">Скрыть</ion-label>
          </ion-button>
          <ion-button class="download-button" @click="openReleaseSetting()"
            v-show="globalContext.isManager && !globalContext.offlineMode">
            <ion-icon :icon="settings"></ion-icon>
            <ion-label class="ion-margin-start">Настройки</ion-label>
          </ion-button>
        </div>
      </div>

      <ion-modal :can-dismiss="true" @didDismiss="showReleaseSettings = false" :is-open="showReleaseSettings"
        class="release-settings-modal">
        <div class="release-settings-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Настройки</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-item lines="none">
                <ion-label>Кеш аудио</ion-label>
                <ion-icon :icon="reload" slot="end" v-show="!cacheReloadProgress.get('music')?.downloading"
                  @click="reloadAudioCache()"></ion-icon>
                <ion-label v-show="cacheReloadProgress.get('music')?.downloading" slot="end">{{
                  Math.round(
                    ((cacheReloadProgress.get("music")?.currentValue || 0) /
                      (cacheReloadProgress.get("music")?.maxValue || 1)) *
                    100
                  )
                }}%</ion-label>
              </ion-item>
              <ion-item lines="none">
                <ion-label>Кеш видео</ion-label>
                <ion-icon :icon="reload" slot="end" v-show="!cacheReloadProgress.get('video')?.downloading"
                  @click="reloadVideoCache()"></ion-icon>
                <ion-label slot="end" v-show="cacheReloadProgress.get('video')?.downloading">{{
                  Math.round(
                    ((cacheReloadProgress.get("video")?.currentValue || 0) /
                      (cacheReloadProgress.get("video")?.maxValue || 1)) *
                    100
                  )
                }}%</ion-label>
              </ion-item>
            </ion-card-content>
            <div class="release-settings-btn-container">
              <ion-button @click="showReleaseSettings = false" :disabled="cacheReloadProgress.get('video')?.downloading ||
                  cacheReloadProgress.get('music')?.downloading
                  ">
                Закрыть
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <!-- Video Download Mode Dialog -->
      <ion-modal :can-dismiss="true" @didDismiss="showVideoDownloadDialog = false" :is-open="showVideoDownloadDialog"
        class="video-download-modal">
        <div class="release-settings-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выберите режим загрузки</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-item lines="none" button @click="downloadAllVideos()">
                <ion-icon :icon="cloudDownload" slot="start"></ion-icon>
                <ion-label>
                  <h2>Загрузить все видео</h2>
                  <p>Загрузить все {{ videoList.length }} видео файлов</p>
                </ion-label>
              </ion-item>
              <ion-item lines="none" button @click="showVideoSelectDialogHandler()">
                <ion-icon :icon="cloudDownloadOutline" slot="start"></ion-icon>
                <ion-label>
                  <h2>Выбрать видео</h2>
                  <p>Выбрать отдельные видео для загрузки</p>
                </ion-label>
              </ion-item>
            </ion-card-content>
            <div class="release-settings-btn-container">
              <ion-button @click="showVideoDownloadDialog = false">
                Отмена
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <!-- Video Selection Dialog -->
      <ion-modal :can-dismiss="true" @didDismiss="showVideoSelectDialog = false" :is-open="showVideoSelectDialog"
        class="video-select-modal">
        <div class="release-settings-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выберите видео</ion-card-title>
            </ion-card-header>
            <ion-card-content class="video-select-content">
              <ion-list>
                <ion-item 
                  v-for="video in videoList" 
                  :key="video.id"
                  :class="['video-select-item', isVideoOffline(video.id) ? 'offline-item' : '']"
                >
                  <ion-label>
                    <h2>{{ formatVideoName(video.name) }}</h2>
                    <p>{{ getVideoStatus(video.id) }}</p>
                  </ion-label>
                  <div slot="end" class="video-select-actions">
                    <ion-icon 
                      :icon="cloudDone" 
                      v-show="isVideoOffline(video.id) && !isVideoDownloading(video.id)"
                      class="video-select-icon"
                    ></ion-icon>
                    <ion-icon 
                      :icon="cloudDownloadOutline" 
                      v-show="!isVideoOffline(video.id) && !isVideoDownloading(video.id)"
                      class="video-select-icon"
                      @click="downloadSingleVideo(video)"
                    ></ion-icon>
                    <ion-icon 
                      :icon="stopCircle" 
                      v-show="isVideoDownloading(video.id)"
                      class="video-select-icon"
                      @click="stopVideoDownload(video)"
                    ></ion-icon>
                    <ion-icon 
                      :icon="trash" 
                      v-show="isVideoOffline(video.id) && !isVideoDownloading(video.id)"
                      class="video-select-icon"
                      @click="removeSingleVideo(video)"
                    ></ion-icon>
                  </div>
                </ion-item>
              </ion-list>
            </ion-card-content>
            <div class="release-settings-btn-container">
              <ion-button @click="showVideoSelectDialog = false">
                Закрыть
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <ion-toast cssClass="custom-toast" :is-open="isDownloading"
        message="Не закрывайте приложение и окно до завершения процесса" position="top" color="dark">
      </ion-toast>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from "@/model/globalcontext.model";
import { GoogleMedia } from "@/model/googlemedia.model";
import { MediaProgressBar } from "@/model/mediaprogressbar.model";
import { PlayerModes } from "@/model/player.mode";
import { PlayerBar } from "@/model/playerbar.model";
import { Playlist } from "@/model/playlist.model";
import { Release } from "@/model/release.model";
import FilesystemCustomUtils from "@/services/filesystem.custom.utils";
import UnicodeUtils from "@/services/unicode.utils";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation";
import { Capacitor, CapacitorHttp } from "@capacitor/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { Preferences } from "@capacitor/preferences";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonPage,
  IonText,
  IonToast,
} from "@ionic/vue";
import axios from "axios";
import {
  arrowBackOutline,
  close,
  cloudDone,
  cloudDownload,
  cloudDownloadOutline,
  cloudOutline,
  documentOutline,
  eye,
  eyeOff,
  filmOutline,
  homeOutline,
  musicalNotesOutline,
  reload,
  settings,
  stopCircle,
  trash,
} from "ionicons/icons";
import { defineComponent, inject, ref } from "vue";
// @ts-ignore
import { MittEmitter } from "mitt-emitter";

export default defineComponent({
  name: "ReleasePage",
  components: {
    IonContent,
    IonPage,
    IonButton,
    IonIcon,
    IonList,
    IonListHeader,
    IonItem,
    IonLabel,
    IonText,
    IonToast,
    IonModal,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
  },

  setup() {
    const playerBar = inject("playerBar") as PlayerBar;
    const releaseEntity = inject("release") as Release;
    const programImageRef = ref();
    const globalContext = inject("globalContext") as GlobalContext;
    const isMobile = globalContext.isMobile;
    const filesystemCustomUtils = new FilesystemCustomUtils();
    const unicodeUtils = new UnicodeUtils();
    const emitter = inject("emitter") as MittEmitter;

    const mimeExtensions: Map<string, string> = new Map([
      ["image/jpeg", "jpg"],
      ["image/png", "png"],
      ["application/json", "json"],
      ["audio/mpeg", "mp3"],
      ["video/mp4", "mp4"],
      ["video/mpeg", "mpeg"],
      ["video/quicktime", "mov"],
      ["application/pdf", "pdf"],
    ]);

    return {
      musicalNotesOutline,
      filmOutline,
      documentOutline,
      arrowBackOutline,
      cloudDownload,
      cloudDownloadOutline,
      cloudDone,
      cloudOutline,
      stopCircle,
      trash,
      close,
      playerBar,
      releaseEntity,
      programImageRef,
      mimeExtensions,
      eye,
      eyeOff,
      globalContext,
      isMobile,
      filesystemCustomUtils,
      unicodeUtils,
      emitter,
      settings,
      reload,
      homeOutline,
    };
  },

  data() {
    return {
      storedReleaseImagePath: "",
      musicList: Array<GoogleMedia>(),
      videoList: Array<GoogleMedia>(),
      showOfflineSelector: false,
      programName: "",
      programShortName: "",
      releaseId: 0,
      release: "",
      releaseVisible: false,
      releaseWithZero: "",
      musicDirectory: "",
      videoDirectory: "",
      guideDirectory: "",
      imageDirectory: "",
      showReleaseSettings: false,
      prevRouteName: "",
      isLandscapeMode: false,

      cacheReloadProgress: new Map<string, MediaProgressBar>([
        ["music", new MediaProgressBar()],
        ["video", new MediaProgressBar()],
        ["guide", new MediaProgressBar()],
      ]),

      downloadProgress: new Map<string, MediaProgressBar>([
        ["music", new MediaProgressBar()],
        ["video", new MediaProgressBar()],
        ["guide", new MediaProgressBar()],
      ]),

      // Video download dialogs
      showVideoDownloadDialog: false,
      showVideoSelectDialog: false,
      currentEntityType: '',
      downloadingVideos: new Map<string, boolean>(),
      offlineVideos: new Map<string, boolean>(),
      
      // Track active download utils instances for cancellation
      activeDownloadUtils: new Map<string, FilesystemCustomUtils>(),
    };
  },

  computed: {
    isDownloading(): boolean {
      let isDownloading = false;
      this.downloadProgress.forEach((progress) => {
        if (progress.downloading) isDownloading = true;
      });

      return isDownloading;
    },
  },

  mounted() {
    try {
      if (this.isMobile) {
        this.isLandscapeMode =
          ScreenOrientation.type ==
          ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
          ScreenOrientation.type ==
          ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
          ScreenOrientation.type ==
          ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        ScreenOrientation.onChange().subscribe(() => {
          this.isLandscapeMode =
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        });
      }
    } catch (ex) {
      //not supported
    }
  },

  ionViewWillEnter() {
    setTimeout(() => {
      if (this.globalContext.isLoading) {
        this.globalContext.isLoading = false;
      }
    }, 3000);

    Preferences.get({ key: "releaseMeta" }).then((releaseMeta) => {
      if (releaseMeta.value) {
        const releaseMetaData = JSON.parse(releaseMeta.value);
        this.prevRouteName = String(releaseMetaData.prevRouteName || '');
        this.programName = String(releaseMetaData.programName);
        this.programShortName = String(releaseMetaData.programShortName);
        this.releaseId = Number(releaseMetaData.releaseId);
        this.release = String(releaseMetaData.release);
        this.releaseVisible = releaseMetaData.releaseVisible === "true";
        this.releaseWithZero =
          this.release && this.release.length === 1
            ? "0" + this.release
            : this.release;
        this.musicDirectory = `${this.programShortName + "_" + this.releaseWithZero + "_Music"
          }`;
        this.videoDirectory = `${this.programShortName + "_" + this.releaseWithZero + "_Video"
          }`;
        this.guideDirectory = `${this.programShortName + "_" + this.releaseWithZero + "_Guide"
          }`;
        this.imageDirectory = `${this.programShortName + "_" + this.releaseWithZero + "_Image"
          }`;

        this.releaseEntity.clearFields();
        this.releaseEntity.programName = this.programName;
        this.releaseEntity.programShortName = this.programShortName;
        this.releaseEntity.id = this.releaseId;
        this.releaseEntity.release = this.release;
        this.releaseEntity.visible = this.releaseVisible;
        this.releaseEntity.releaseWithZero = this.releaseWithZero;
        this.releaseEntity.musicDirectory = this.musicDirectory;
        this.releaseEntity.videoDirectory = this.videoDirectory;
        this.releaseEntity.guideDirectory = this.guideDirectory;
        this.releaseEntity.imageDirectory = this.imageDirectory;

        const releaseImagePath = `${this.programShortName}_${this.release && this.release.length === 1
          ? "0" + this.release
          : this.release
          }.png`;

        if (this.isMobile) {
          let storedImageExists = false;
          Filesystem.readdir({
            path: this.imageDirectory,
            directory: Directory.Data,
          })
            .then((response) => {
              storedImageExists = response.files.length > 0 && response.files[0].size > 0;
            })
            .catch(() => {
              console.error("Stored image not found");
            }).finally(() => {
              if (this.globalContext.offlineMode && storedImageExists) {
                this.globalContext.isLoading = false;
                Filesystem.getUri({
                  path: `${this.imageDirectory}/${releaseImagePath}`,
                  directory: Directory.Data,
                }).then((storedImage) => {
                  this.storedReleaseImagePath = Capacitor.convertFileSrc(
                    storedImage.uri
                  );
                  this.releaseEntity.imagePath = releaseImagePath;
                });
              } else if (!this.globalContext.offlineMode) {
                Filesystem.mkdir({
                  path: this.imageDirectory,
                  directory: Directory.Data,
                })
                .catch(() => {
                  // directory exists
                })
                .finally(() => {
                  Preferences.get({ key: "jwt" }).then((tokenQuery) => {
                    CapacitorHttp.get({
                      url: `${process.env.VUE_APP_API_EXT_URL}api/google/file/base64/name/${releaseImagePath}`,
                      headers: { Authorization: `Bearer ${tokenQuery.value}` },
                      readTimeout: 120000,
                    })
                      .then((response) => {
                        Filesystem.writeFile({
                          path: `${this.imageDirectory}/${releaseImagePath}`,
                          data: response.data,
                          directory: Directory.Data,
                        })
                          .then((storedImage) => {
                            this.storedReleaseImagePath = Capacitor.convertFileSrc(
                              storedImage.uri
                            );
                            this.releaseEntity.imageDirectory = this.imageDirectory;
                            this.releaseEntity.imagePath = releaseImagePath;
                          })
                          .catch(() => {
                            this.storedReleaseImagePath = `data:image/jpg;base64,${response.data}`;
                          })
                          .finally(() => {
                            this.globalContext.isLoading = false;
                          });
                      })
                      .catch(() => {
                        this.globalContext.isLoading = false;
                      });
                  });
                });
              } else {
                this.globalContext.isLoading = false;
              }
            });
        } else {
          if (!this.globalContext.offlineMode) {
            axios
              .get(
                `${process.env.VUE_APP_API_EXT_URL}api/google/file/base64/name/${releaseImagePath}`
              )
              .then((response) => {
                this.storedReleaseImagePath = `data:image/jpg;base64,${response.data}`;
                this.releaseEntity.imagePath = releaseImagePath;
              })
              .finally(() => {
                this.globalContext.isLoading = false;
              });
          }
        }

        this.isOffline();
        
        // Check individual video offline status
        if (this.videoList.length > 0) {
          this.checkVideoOfflineStatus();
        }
      }
    });

    if (
      this.playerBar.currentMode === PlayerModes.MICRO ||
      this.playerBar.microMode
    ) {
      this.playerBar.currentMode = PlayerModes.EXTENDED;
      this.playerBar.microMode = false;
      this.playerBar.visible = true;
    }
  },

  ionViewWillLeave() {
    this.storedReleaseImagePath = "";
  },

  methods: {
    returnBack(componentName?: string) {
      if (componentName === 'Program') {
        Preferences.set({
          key: "programMeta",
          value: JSON.stringify({
            programName: this.programName,
            programShortName: this.programShortName,
          }),
        })
      }
      this.$router.replace({
        name: componentName && componentName !== '' ? componentName : "Programs",
      });
    },
    openReleaseDetail(releaseDetail: string) {
      this.isOffline();

      this.$router.push({
        name: releaseDetail,
      });
    },

    hideOfflineSelector() {
      this.showOfflineSelector = false;
    },

    clearProgressBar(entityType: string) {
      const entityProgressBar = this.downloadProgress.get(entityType);
      if (entityProgressBar) {
        entityProgressBar.currentValue = 0;
        entityProgressBar.maxValue = 0;
        entityProgressBar.downloaded = 0;
        entityProgressBar.downloading = false;
      }
    },

    async stopDownload(entityType: string) {
      console.log(`Stopping download for ${entityType}`);
      
      // Get the active download utils instance if it exists
      let filesystemCustomUtils = this.activeDownloadUtils.get(entityType);
      
      // If no active instance, create one for cleanup
      if (!filesystemCustomUtils) {
        console.log(`No active download instance for ${entityType}, creating new one for cleanup`);
        filesystemCustomUtils = new FilesystemCustomUtils();
        filesystemCustomUtils.setRelease(
          this.releaseEntity.programName,
          this.releaseEntity.programShortName,
          this.releaseEntity.releaseWithZero
        );
      } else {
        // Cancel all downloads using the same instance
        filesystemCustomUtils.cancelAllDownloads();
      }
      
      // Clean up partial files
      const tempPlaylist = new Playlist('', '', '');
      if (entityType === 'music') {
        tempPlaylist.id = this.musicDirectory;
      } else if (entityType === 'video') {
        tempPlaylist.id = this.videoDirectory;
      } else if (entityType === 'guide') {
        tempPlaylist.id = this.guideDirectory;
      }
      
      if (tempPlaylist.id) {
        console.log(`Cleaning up partial downloads for ${tempPlaylist.id}`);
        await filesystemCustomUtils.cleanupPartialDownloads(tempPlaylist);
      }
      
      // Remove from active downloads
      this.activeDownloadUtils.delete(entityType);
      
      this.clearProgressBar(entityType);
      this.isOffline(entityType);
    },

    breakAllActiveDownloads() {
      //stop music
      const musicProgressbar = this.downloadProgress.get("music");
      if (undefined !== musicProgressbar && musicProgressbar.downloading) {
        this.stopDownload("music");
        setTimeout(() => {
          this.removeReleaseEntityDirectory("music");
        }, 5000);
      }
      //stop video
      const videoProgressbar = this.downloadProgress.get("video");
      if (undefined !== videoProgressbar && videoProgressbar.downloading) {
        this.stopDownload("video");
        setTimeout(() => {
          this.removeReleaseEntityDirectory("video");
        }, 5000);
      }
      //stop guide
      const guideProgressbar = this.downloadProgress.get("guide");
      if (undefined !== guideProgressbar && guideProgressbar.downloading) {
        this.stopDownload("guide");
        setTimeout(() => {
          this.removeReleaseEntityDirectory("guide");
        }, 5000);
      }
    },

    createUuid(): string {
      let dt = new Date().getTime();
      const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },

    async downloadRelease(entityType: string) {
      // For video, show dialog to choose download mode
      if (entityType === 'video') {
        this.currentEntityType = entityType;
        await this.fetchVideoList();
        this.showVideoDownloadDialog = true;
        return;
      }

      // For music and guide, proceed with normal download
      this.removeReleaseEntityDirectory(entityType).then((result) => {
        if (result) {
          const filesystemCustomUtils = new FilesystemCustomUtils();
          this.activeDownloadUtils.set(entityType, filesystemCustomUtils); // Track instance for cancellation
          
          const entityProgressBar = this.downloadProgress.get(entityType);
          if (typeof entityProgressBar !== "undefined") {
            entityProgressBar.downloading = true;
            entityProgressBar.id = this.createUuid();
            entityProgressBar.startDownload(); // Initialize timing
            filesystemCustomUtils.setProgressBar(entityProgressBar); // Set progress bar

            this.emitter.on(`downloaded-${entityProgressBar.id}`, () => {
              if ("music" == entityType) this.releaseEntity.musicOffline = true;
              else if ("video" == entityType)
                this.releaseEntity.videoOffline = true;
              else if ("guide" == entityType)
                this.releaseEntity.guideOffline = true;
              
              // Remove from active downloads when complete
              this.activeDownloadUtils.delete(entityType);
            });
          }
          filesystemCustomUtils.setRelease(
            this.releaseEntity.programName,
            this.releaseEntity.programShortName,
            this.releaseEntity.releaseWithZero
          );
          filesystemCustomUtils.setEmitter(this.emitter);

          filesystemCustomUtils.downloadRelease(entityType);
        }
      });
    },

    async fetchVideoList() {
      try {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/google/media/${this.releaseEntity.videoDirectory}`,
          headers: { Authorization: `Bearer ${token}` },
          readTimeout: 60000,
        };

        const response = await CapacitorHttp.get(options);
        this.videoList = response.data;
      } catch (error) {
        console.error('Failed to fetch video list', error);
      }
    },

    async downloadSingleVideo(video: GoogleMedia) {
      if (!video) return;

      this.downloadingVideos.set(video.id, true);

      try {
        const filesystemCustomUtils = new FilesystemCustomUtils();
        filesystemCustomUtils.setRelease(
          this.releaseEntity.programName,
          this.releaseEntity.programShortName,
          this.releaseEntity.releaseWithZero
        );

        // Download single video file directly (no progress bar needed for single files)
        await filesystemCustomUtils.downloadFileChunked(
          video.id,
          this.releaseEntity.videoDirectory,
          video.mimeType
        );

        this.offlineVideos.set(video.id, true);
        
        // Check if all videos are now offline
        await this.checkVideoOfflineStatus();
        this.isOffline('video');
      } catch (error) {
        console.error('Failed to download video', error);
      } finally {
        this.downloadingVideos.delete(video.id);
      }
    },

    async downloadAllVideos() {
      this.showVideoDownloadDialog = false;
      
      this.removeReleaseEntityDirectory(this.currentEntityType).then((result) => {
        if (result) {
          const filesystemCustomUtils = new FilesystemCustomUtils();
          this.activeDownloadUtils.set(this.currentEntityType, filesystemCustomUtils); // Track instance
          
          const entityProgressBar = this.downloadProgress.get(this.currentEntityType);
          if (typeof entityProgressBar !== "undefined") {
            entityProgressBar.downloading = true;
            entityProgressBar.id = this.createUuid();
            entityProgressBar.startDownload(); // Initialize timing
            filesystemCustomUtils.setProgressBar(entityProgressBar); // Set progress bar BEFORE download

            this.emitter.on(`downloaded-${entityProgressBar.id}`, () => {
              this.releaseEntity.videoOffline = true;
              this.isOffline('video'); // Refresh offline status
              this.activeDownloadUtils.delete(this.currentEntityType); // Remove when complete
            });
          }
          filesystemCustomUtils.setRelease(
            this.releaseEntity.programName,
            this.releaseEntity.programShortName,
            this.releaseEntity.releaseWithZero
          );
          filesystemCustomUtils.setEmitter(this.emitter);

          filesystemCustomUtils.downloadRelease(this.currentEntityType);
        }
      });
    },

    formatTimeRemaining(progressBar?: MediaProgressBar): string {
      if (!progressBar || !progressBar.downloading) {
        return '--:--';
      }
      return progressBar.getFormattedTimeRemaining();
    },

    async showVideoSelectDialogHandler() {
      this.showVideoDownloadDialog = false;
      
      // Check which videos are already offline
      await this.checkVideoOfflineStatus();
      
      this.showVideoSelectDialog = true;
    },

    async checkVideoOfflineStatus() {
      try {
        const dirContent = await Filesystem.readdir({
          path: this.videoDirectory,
          directory: Directory.Data,
        });

        // Clear previous state
        this.offlineVideos.clear();

        // Check each video in the list
        for (const video of this.videoList) {
          const fileExtension = this.mimeExtensions.get(video.mimeType || '') || 'mp4';
          const fileName = `${video.id}.${fileExtension}`;
          
          const fileExists = dirContent.files.some(f => 
            f.name === fileName && !f.name.startsWith('dwn_') && f.size > 0
          );
          
          if (fileExists) {
            this.offlineVideos.set(video.id, true);
          }
        }
      } catch (error) {
        console.log('Video directory not found or empty', error);
        this.offlineVideos.clear();
      }
    },

    isVideoOffline(videoId: string): boolean {
      return this.offlineVideos.has(videoId);
    },

    isVideoDownloading(videoId: string): boolean {
      return this.downloadingVideos.has(videoId);
    },

    getVideoStatus(videoId: string): string {
      if (this.isVideoOffline(videoId)) {
        return 'Оффлайн';
      } else if (this.isVideoDownloading(videoId)) {
        return 'Загрузка...';
      }
      return '';
    },

    formatVideoName(name: string): string {
      if (!name) return '';
      const pattern = /(\d{2})_(.*?)\.mp4/;
      const match = name.match(pattern);
      if (match) {
        const prefix = parseInt(match[1], 10);
        let formattedName = match[2];
        if (prefix > 0) {
          formattedName = `${prefix} - ${formattedName}`;
        }
        return formattedName;
      }
      return name;
    },

    async stopVideoDownload(video: GoogleMedia) {
      if (!video) return;

      this.downloadingVideos.delete(video.id);

      const filesystemCustomUtils = new FilesystemCustomUtils();
      filesystemCustomUtils.setRelease(
        this.releaseEntity.programName,
        this.releaseEntity.programShortName,
        this.releaseEntity.releaseWithZero
      );

      const tempPlaylist = new Playlist('', '', '');
      tempPlaylist.id = this.releaseEntity.videoDirectory;
      tempPlaylist.tracks = [video];

      await filesystemCustomUtils.cleanupPartialDownloads(tempPlaylist);
    },

    async removeSingleVideo(video: GoogleMedia) {
      if (!video) return;

      try {
        const fileExtension = this.mimeExtensions.get(video.mimeType || '') || 'mp4';
        const fileName = `${video.id}.${fileExtension}`;

        await Filesystem.deleteFile({
          path: `${this.releaseEntity.videoDirectory}/${fileName}`,
          directory: Directory.Data
        });

        this.offlineVideos.delete(video.id);
      } catch (error) {
        console.error('Failed to remove video', error);
      }
    },

    isOffline(entityType?: string) {
      if (!entityType || entityType == "music") {
        Filesystem.readdir({
          path: `${this.filesystemCustomUtils.PLAYLISTS_DIRECTORY}/${this.musicDirectory}`,
          directory: Directory.Data,
        })
          .then((musicDirContent) => {
            const foundPlaylist = musicDirContent.files.find((f) => {
              return f.name == this.filesystemCustomUtils.PLAYLIST_PATH;
            });

            if (typeof foundPlaylist !== "undefined" && null != foundPlaylist) {
              Filesystem.readFile({
                path: `${this.filesystemCustomUtils.PLAYLISTS_DIRECTORY}/${this.releaseEntity.musicDirectory}/${this.filesystemCustomUtils.PLAYLIST_PATH}`,
                directory: Directory.Data,
                encoding: Encoding.UTF8,
              })
                .then((res) => {
                  const localPlaylist: Playlist = typeof res.data === 'string' ? JSON.parse(res.data) : null;
                  if (localPlaylist) {
                    this.musicList = localPlaylist.tracks;

                    this.filesystemCustomUtils
                      .isPlaylistOffline(
                        this.filesystemCustomUtils.PLAYLISTS_DIRECTORY,
                        localPlaylist
                      )
                      .then((response) => {
                        this.releaseEntity.musicOffline = response;
                      }).catch((err) => {
                        console.error("Failed to load local music playlist", err);
                        this.releaseEntity.musicOffline = false;
                      });
                  }
                })
                .catch((err) => {
                  console.error("Failed to load local music playlist", err);
                  this.releaseEntity.musicOffline = false;
                });
            }
          })
          .catch(() => {
            this.releaseEntity.musicOffline = false;
          });
      }
      if (!entityType || entityType == "video") {
        Filesystem.readdir({
          path: this.videoDirectory,
          directory: Directory.Data,
        })
          .then((videoDirContent) => {
            const foundPlaylist = videoDirContent.files.find((f) => {
              return f.name == this.filesystemCustomUtils.PLAYLIST_PATH;
            });

            if (typeof foundPlaylist !== "undefined" && null != foundPlaylist) {
              Filesystem.readFile({
                path: `${this.videoDirectory}/${this.filesystemCustomUtils.PLAYLIST_PATH}`,
                directory: Directory.Data,
                encoding: Encoding.UTF8,
              })
                .then((res) => {
                  const localPlaylist: Playlist = typeof res.data === 'string' ? JSON.parse(res.data) : null;
                  if (localPlaylist) {
                    this.videoList = localPlaylist.tracks;

                    this.filesystemCustomUtils
                      .isPlaylistOffline("", localPlaylist)
                      .then((response) => {
                        this.releaseEntity.videoOffline = response;
                        console.log(`Video offline status: ${response}`);
                      });
                  }
                })
                .catch((err) => {
                  console.error("Failed to load local video playlist", err);
                  this.releaseEntity.videoOffline = false;
                });
            } else {
              // No playlist.json found - video is NOT offline
              this.releaseEntity.videoOffline = false;
            }
          })
          .catch(() => {
            this.releaseEntity.videoOffline = false;
          });
      }
      if (!entityType || entityType == "guide") {
        Filesystem.readdir({
          path: this.guideDirectory,
          directory: Directory.Data,
        })
          .then((response) => {
            this.releaseEntity.guideOffline =
              response.files.length > 0 &&
              response.files[0].name.endsWith("png");
          })
          .catch(() => {
            this.releaseEntity.guideOffline = false;
          });
      }
    },

    removeReleaseEntityDirectory(entityType: string): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        const filesystemCustomUtils = new FilesystemCustomUtils();
        const entityProgressBar = this.downloadProgress.get(entityType);
        if (typeof entityProgressBar !== "undefined") {
          entityProgressBar.startDownload();
        }
        filesystemCustomUtils.setRelease(
          this.releaseEntity.programName,
          this.releaseEntity.programShortName,
          this.releaseEntity.releaseWithZero
        );
        filesystemCustomUtils
          .removeReleaseEntityDirectory(entityType)
          .then((response) => {
            if (response) {
              if ("music" == entityType)
                this.releaseEntity.musicOffline = false;
              else if ("video" == entityType)
                this.releaseEntity.videoOffline = false;
              else if ("guide" == entityType)
                this.releaseEntity.guideOffline = false;
            }
            resolve(response);
          });
      });
    },

    async changeReleaseVisibility(value: boolean) {
      this.releaseVisible = value;

      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/liga-releases/publish`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
          data: {
            id: this.releaseEntity.id,
            visible: value,
          },
        };

        await CapacitorHttp.post(options).catch(() => {
          this.$router.replace("/badconnection");
        });
      } else {
        axios
          .post("api/liga-releases/publish", {
            id: this.releaseEntity.id,
            visible: value,
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      }
    },

    async openReleaseSetting() {
      this.showReleaseSettings = true;

      //get cache progress
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const audioOptions = {
        url: `${process.env.VUE_APP_API_URL}api/google/media/read-media-cache-progress`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
        params: {
          progressId: this.releaseEntity.musicDirectory,
        },
      };

      CapacitorHttp.get(audioOptions).then((result) => {
        if (result.data && !isNaN(result.data)) {
          const progressBar =
            this.cacheReloadProgress.get("music") || new MediaProgressBar();
          progressBar.id = this.releaseEntity.musicDirectory;
          progressBar.currentValue = Number(result.data.progressValue);
          progressBar.maxValue = Number(result.data.progressMaxValue);
        }
      });

      const videoOptions = {
        url: `${process.env.VUE_APP_API_URL}api/google/media/read-media-cache-progress`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
        params: {
          progressId: this.releaseEntity.videoDirectory,
        },
      };

      CapacitorHttp.get(videoOptions).then((result) => {
        if (result.data && !isNaN(result.data)) {
          const progressBar =
            this.cacheReloadProgress.get("video") || new MediaProgressBar();
          progressBar.id = this.releaseEntity.videoDirectory;
          progressBar.currentValue = Number(result.data.progressValue);
          progressBar.maxValue = Number(result.data.progressMaxValue);
        }
      });
    },

    async reloadAudioCache() {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/google/media/${this.releaseEntity.musicDirectory}`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };

      const mediaType = "music";
      const progressBar =
        this.cacheReloadProgress.get(mediaType) || new MediaProgressBar();
      progressBar.id = this.releaseEntity.musicDirectory;
      progressBar.currentValue = 0;

      await CapacitorHttp.get(options).then((response) => {
        this.musicList = response.data;
        progressBar.maxValue = this.musicList.length - 1;
        this.reloadCacheRequest(
          token || "",
          this.getCacheFileName(progressBar.currentValue, mediaType),
          mediaType
        );
      });
    },

    async reloadVideoCache() {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/google/media/${this.releaseEntity.videoDirectory}`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };

      const mediaType = "video";
      const progressBar =
        this.cacheReloadProgress.get(mediaType) || new MediaProgressBar();
      progressBar.id = this.releaseEntity.videoDirectory;
      progressBar.currentValue = 0;

      await CapacitorHttp.get(options).then((response) => {
        this.videoList = response.data;
        progressBar.maxValue = this.videoList.length - 1;

        this.reloadCacheRequest(
          token || "",
          this.getCacheFileName(progressBar.currentValue, mediaType),
          mediaType
        );
      });
    },

    getCacheFileName(index: number, mediaType: string): string {
      try {
        if ("music" === mediaType) {
          return `${this.musicList[index].id}.mp3`;
        } else if ("video" === mediaType) {
          return `${this.videoList[index].id}`;
        } else return "";
      } catch (ex) {
        return "";
      }
    },

    reloadCacheRequest(token: string, fileName: string, mediaType: string) {
      const progressBar =
        this.cacheReloadProgress.get(mediaType) || new MediaProgressBar();
      progressBar.downloading =
        progressBar.currentValue <= progressBar.maxValue;

      if (progressBar.downloading) {
        CapacitorHttp.get({
          url: `${process.env.VUE_APP_API_URL}api/google/reload-media-cache`,
          headers: { Authorization: `Bearer ${token}` },
          params: {
            fileName: fileName,
            mediaType: mediaType,
            progressId: String(progressBar.id),
            progressValue: String(progressBar.currentValue),
            progressMaxValue: String(progressBar.maxValue),
          },
          readTimeout: 60000,
        })
          .then(() => {
            progressBar.currentValue = progressBar.currentValue + 1;
            this.reloadCacheRequest(
              token || "",
              this.getCacheFileName(progressBar.currentValue, mediaType),
              mediaType
            );
          })
          .catch(() => {
            console.error("Error reloading media cache");
            progressBar.currentValue = progressBar.maxValue;
            progressBar.downloading = false;
          });
      } else {
        CapacitorHttp.get({
          url: `${process.env.VUE_APP_API_URL}api/google/clear-media-cache-progress`,
          headers: { Authorization: `Bearer ${token}` },
          params: {
            progressId: String(progressBar.id),
          },
          readTimeout: 60000,
        });
      }
    },
  },
});
</script>

<style scoped>
.top-safe-area {
  width: 100vw;
  height: var(--ion-safe-area-top);
}

.logo {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.logo img {
  width: 220px;
  padding-top: 5vh;
  scale: 0.8;
  margin-bottom: 1vh;
}

.page-content {
  position: relative;
  padding-bottom: 20px;
}

.release-page-background {
  width: 100%;
  padding-left: 2vw;
  padding-right: 2vw;
  position: relative;
  margin-top: 20px;
  max-height: 70%;
  min-height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.release-page-background img {
  border-radius: 15px;
  max-height: 70vh;
  max-width: 100%;
  height: auto;
  width: auto;
  object-fit: contain;
}

.media-buttons {
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 30%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}

.media-button {
  color: white;
  --border-radius: 50%;
  --border-style: solid;
  --border-width: 3px;
  --border-color: var(--ion-color-orange);
  --color-activated: var(--ion-color-orange-tint);
  --background-hover-opacity: 0;
  --background-activated: transparent;
  --background-activated-opacity: 0;
  --background-focused: transparent;
  --background: rgba(32, 33, 75, 0.7);
  height: 10vh;
  width: 10vh;
}

.media-button ion-icon {
  font-size: 2em;
}

.media-button-middle {
  margin-left: 4vh;
  margin-right: 4vh;
}

.bottom-buttons-container {
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 5%;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
}

.download-button {
  color: white;
  --background: rgba(40, 40, 40, 0.7);
  --border-color: var(--ion-color-orange);
  --border-style: solid;
  --border-width: 1px;
  --color-activated: var(--ion-color-orange-tint);
  --background-activated: transparent;
  --background-activated-opacity: 0;
  max-width: 80%;
  letter-spacing: 0.15em;
}

.download-button ion-label {
  font-size: 1em;
  text-transform: none !important;
}

.admin-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.admin-buttons ion-label {
  margin-top: 2.5px;
}

.bottom-buttons-container-landscape {
  position: absolute;
  left: 80% !important;
  top: 0 !important;
  bottom: unset !important;
}

.admin-buttons-landscape {
  flex-flow: column;
}

.release-settings-modal {
  --background: rgba(67, 67, 67, 0.5) !important;
  --backdrop-opacity: 0.3;
}

.release-settings-card-container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-flow: column;
  height: 100vh;
}

.release-settings-card-container ion-card {
  padding: 20px;
  max-height: 90%;
  overflow: scroll;
  --background: #1f1f1f !important;
}

.release-settings-card-container ion-card-title {
  color: white;
  font-weight: bold;
  font-size: 1.8em;
  letter-spacing: 0.07em;
}

.release-settings-card-container ion-card-content {
  color: rgba(255, 255, 255, 0.5);
  font-weight: bold;
  font-size: 1em;
  letter-spacing: 0.07em;
}

.release-settings-card-container ion-item {
  --background: transparent !important;
  color: white !important;
}

.release-settings-card-container ion-item ion-icon {
  color: white !important;
  cursor: pointer;
}

.release-settings-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.release-settings-btn-container ion-button {
  --background: transparent;
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
  --border-color: var(--ion-color-orange) !important;
  --border-style: solid !important;
  --border-width: 1px !important;
}

.info-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8em;
}

.offline-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  background-color: rgba(31, 31, 31, .8);
}

.video-details-content {
  background-color: rgba(45, 52, 54, 0.8);
  padding: 8px 0;
}

.video-detail-item {
  padding-left: 48px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 48px;
}

.video-detail-item:last-child {
  border-bottom: none;
}

.video-name {
  font-size: 0.9em;
  font-weight: 500;
}

.video-status {
  font-size: 0.75em;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 2px;
}

.video-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.video-icon {
  font-size: 1.2em;
  color: var(--ion-color-orange);
  cursor: pointer;
  transition: transform 0.2s;
}

.video-icon:hover {
  transform: scale(1.1);
}

/* Video Download Modal Styles */
.video-download-modal {
  --background: rgba(67, 67, 67, 0.5) !important;
  --backdrop-opacity: 0.3;
}

.video-select-modal {
  --background: rgba(67, 67, 67, 0.5) !important;
  --backdrop-opacity: 0.3;
}

.video-select-content {
  max-height: 50vh;
  overflow-y: auto;
}

.video-select-content ion-list {
  background-color: transparent !important;
  padding: 0;
}

.video-select-item {
  --background: #2a2a2a !important;
  background-color: #2a2a2a !important;
  color: white !important;
  border-bottom: none;
  margin-bottom: 0;
  border-radius: 0;
}

.video-select-item h2 {
  font-size: 0.95em;
  font-weight: 500;
  margin-bottom: 4px;
}

.video-select-item p {
  font-size: 0.8em;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.video-select-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.video-select-icon {
  font-size: 1.3em;
  color: var(--ion-color-orange);
  cursor: pointer;
  transition: transform 0.2s;
}

.video-select-icon:hover {
  transform: scale(1.1);
}

.offline-select-container {
  background-color: #2d3436;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 16px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  width: 100%;
  height: auto;
  z-index: 11000;
}

.offline-select-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  z-index: 11000;
}

.offline-select-header {
  background-color: #2d3436;
}

.close-icon {
  font-size: 24px;
  color: var(--ion-color-orange);
  transition: color 0.3s;
  z-index: 11000;
}

.close-icon:hover {
  color: var(--ion-color-orange);
}

ion-list {
  background-color: #2d3436;
  z-index: 11000;
}

ion-list-header {
  font-size: 18px;
  font-weight: bold;
  color: white;
  margin: 12px 0;
  letter-spacing: .08em;
  border-bottom: 1px solid rgba(255, 255, 255, .5);
  z-index: 11000;
}

.offline-progress {
  height: 6px;
  background-color: #4caf50;
  border-radius: 3px;
  transition: width 0.4s ease;
  z-index: 11000;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 20%;
}

.offline-progress-bottom {
  height: 4px;
  background-color: #4caf50;
  border-radius: 2px;
  transition: width 0.4s ease;
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  z-index: 11001;
}

ion-item {
  background-color: #212121;
  --background: transparent !important;
  padding: 12px 16px;
  padding-bottom: 16px;
  border-radius: 6px;
  margin: 10px 0;
  transition: background 0.3s;
  z-index: 11000;
  position: relative;
  overflow: visible;
}

ion-item:hover {
  background-color: #545454;
}

ion-icon {
  font-size: 20px;
  color: var(--ion-color-orange);
  transition: color 0.3s;
  cursor: pointer;
  z-index: 11000;
}

ion-icon:hover {
  color: var(--ion-color-orange);
}

.online-item {
  color: var(--ion-color-orange);
  z-index: 11000;
}

.offline-item {
  color: #4caf50;
  font-weight: bold;
  letter-spacing: .08em;
  z-index: 11000;
}
</style>